import auth0 from 'auth0-js'

export const getWebAuth = (redirectUri) => {
  return new auth0.WebAuth({
    clientID: process.env.REACT_APP_AUTH0_CLIENTID,
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    responseType: 'token id_token',
    scope: 'openid profile',
    prompt: 'none',
    redirectUri,
  })
}
